import {
  ICallcardButtonEvent,
  ICallcardButtonTool,
  ToolColor,
  ToolExpand,
  ToolFill,
  ToolSize,
  ToolType
} from '@addins/core/singlecallcard';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { Observable, Subject } from 'rxjs';

export class EngagedPeopleCardButton implements ICallcardButtonTool {
  readonly ENGAGED_PEOPLE_TITLE: string = 'Mobile.Engaged';

  private readonly _click = new Subject<ICallcardButtonEvent>();
  get onClick(): Observable<ICallcardButtonEvent> {
    return this._click.asObservable();
  }

  readonly icon: string = 'people-circle-outline';
  position: number = 100;
  show: boolean;
  text: string = this.ENGAGED_PEOPLE_TITLE;
  dontTranslate: boolean = true;
  type: ToolType;

  color: ToolColor;
  expand: ToolExpand;
  fill: ToolFill;
  size: ToolSize;

  click(card: CallCard): void {
    this._click.next({ target: card });
  }
}
